import { api as notesApi } from './auto-generated/notes'

notesApi.enhanceEndpoints({
  endpoints: {
    notesCreateStickyNote: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        let patchResult
        try {
          const { data: newNote } = await queryFulfilled
          patchResult = dispatch(
            notesApi.util.updateQueryData('notesGetStickyNotes', {}, (draftNotes) => {
              draftNotes.unshift({
                id: newNote?.id,
                ...args.stickyNoteCreateRequest,
              })
            }),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
    notesUpdateStickyNote: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        let patchResult
        try {
          const { data: updatedNote } = await queryFulfilled
          patchResult = dispatch(
            notesApi.util.updateQueryData('notesGetStickyNotes', {}, (draftNotes) => {
              return draftNotes.map((item) => {
                if (item?.id === args?.noteId) {
                  return updatedNote
                } else {
                  return item
                }
              })
            }),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
    notesDeleteStickyNote: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        let patchResult
        try {
          await queryFulfilled
          patchResult = dispatch(
            notesApi.util.updateQueryData('notesGetStickyNotes', {}, (draftNotes) => {
              return draftNotes?.filter((item) => item?.id !== args?.noteId)
            }),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
  },
})

export { notesApi }
